// extracted by mini-css-extract-plugin
module.exports = {"resultItem":"ReviewsSearchBox_resultItem__hvAWC"};